import { Outlet } from 'react-router';

const Admin = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Admin;
